export default "__VITE_ASSET__Zi4HQ37A__"